// extracted by mini-css-extract-plugin
export default {"checkbox":"_2ywhQ","label-unset-font":"_1bhzA","labelUnsetFont":"_1bhzA"};